module.exports = __webpack_public_path__ + "static/media/ic-no-additional-fees.249dc4cc.svg";